/**
 * Due lingue, un controllo: IT oppure EN, visibile prima e dopo l'accesso.
 */
import { useLocale, useT } from '../i18n/LocaleProvider'

export function LanguageSwitch(): JSX.Element {
  const { locale, setLocale } = useLocale()
  const t = useT()
  return (
    <div className="lang-switch" role="group" aria-label={t('lang.group')}>
      <button type="button" aria-pressed={locale === 'it'} onClick={() => setLocale('it')}>
        IT
      </button>
      <button type="button" aria-pressed={locale === 'en'} onClick={() => setLocale('en')}>
        EN
      </button>
    </div>
  )
}
